<template>
  <v-container fluid>
    <v-layout class="mb-4">
      <v-flex xs6 md6>
        <h3 class="title font-weight-bold">Places</h3>
      </v-flex>
      <v-flex xs6 md6 class="text-xs-right">
        <el-button @click="createDialog=true" type="danger" size="small">Create new</el-button>
      </v-flex>
    </v-layout>
    <template v-if="poiList.length>0">
      <el-table :data="poiList" style="width: 100%">
        <el-table-column label="ID" width="100">
          <template slot-scope="props">{{props.row.poi_id | numFormat('00000')}}</template>
        </el-table-column>
        <el-table-column label="Status" width="100">
          <template slot-scope="props">
            <div
              v-if="props.row.poi_status=='published'"
              class="green lighten-2 badge-status"
            >{{props.row.poi_status}}</div>
            <div
              v-if="props.row.poi_status!='published'"
              class="red lighten-2 badge-status"
            >{{props.row.poi_status}}</div>
          </template>
        </el-table-column>
        <el-table-column label="Type" width="120">
          <template slot-scope="props">{{props.row.poi_type}}</template>
        </el-table-column>
        <el-table-column label="City" width="120">
          <template slot-scope="props">
            <div v-if="props.row.city!=null">{{props.row.city.city_locale.name.th}}</div>
          </template>
        </el-table-column>
        <el-table-column label="Name">
          <template slot-scope="props">{{props.row.poi_name}}</template>
        </el-table-column>
        <el-table-column label="Last Sync" width="120">
          <template slot-scope="props">{{props.row.last_sync| moment("DD/MM/YY HH:mm")}}</template>
        </el-table-column>
        <el-table-column label align="right" width>
          <template slot-scope="props">
            <router-link :to="'/pois/view/'+props.row.poi_id">
              <el-button type="text" size="small">Detail</el-button>
            </router-link>
          </template>
        </el-table-column>
      </el-table>
    </template>

    <create-poi-dialog :dialog="createDialog" @close="createDialog=false"></create-poi-dialog>
    <poi-detail :dialog="detailDrawer" :poi="selectedPoi" @close="detailDrawer=false"></poi-detail>
  </v-container>
</template>

<script>
import Service from "../../services";
import CreatePoiDialog from "../../components/poi/CreatePoiDialog";
import PoiDetail from "../../components/poi/PoiDetail";
export default {
  components: {
    CreatePoiDialog,
    PoiDetail
  },
  data() {
    return {
      createDialog: false,
      detailDrawer: false,
      selectedPoi: null,
      poiList: []
    };
  },
  created() {
    Service.Cms.getPois().then(res => {
      this.poiList = res.data;
    });
  },
  methods: {
    viewItem(item) {
      //this.selectedPoi = item;
      //this.detailDrawer = true;
      this.$router.push("/pois/view/" + item.poi_id);
    }
  }
};
</script>